import React from 'react';
import {Form, Header} from 'semantic-ui-react';
import {
  TextBoxField,
  InlineSelect,
  RadioField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import _ from 'lodash';

import REGION_OPTIONS from '../taskList/regions';

export class WorkloadFilter extends React.Component {
  constructor(props) {
    super(props);
  }

  handleDateFilter = (e, {name, value}) => {
    name = e.target.name;
    this.setFilter(e, {name, value});
  };

  setCheckboxFilter = (name) => {
    var {filters} = this.props;
    filters[name] = !filters[name];
    this.props.onFilterChange(filters);
  };

  setFilter = (event, data) => {
    let {name, value} = data;
    const filtersAsEntered = _.cloneDeep(this.props.filtersAsEntered);
    filtersAsEntered[name] = value;
    this.props.onFilterChange(filtersAsEntered);
  };
  setSelectFilter = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setFilter(event, {name, value});
  };
  setSelectFilterFollow = (event) => {
    const name = event.target.name;
    let value = event.target.value;

    if (name === 'followUpRequired') {
      if (value === 'true') value = true;
      else if (value === 'false') value = false;
    }
    this.setState({[name]: value});
    this.setFilter(event, {name, value});
  };

  clearAllFilters = () => {
    this.props.onFilterChange({
      sortOrder: 'desc',
      sortBy: 'created',
      grantId: '',
      subGrantId: '',
      organizationState: '',
      assignee: '',
      region: '',
      fundingOpportunityNumber: '',
      organizationName: '',
      phase: '',
      name: '',
      followUpRequired: '',
    });
  };

  render() {
    const {filters, filtersAsEntered, workloadHMAToggle} = this.props;
    const filtered = _.filter(this.props.assigneeList, function (el) {
      return el != null;
    });

    const assigneeOptions = _.concat(
      [{key: 0, value: '', text: ''}],
      [{key: 'unassigned', value: 'unassigned', text: 'unassigned'}],
      _.map(_.sortBy(_.values(filtered)), (item) => ({
        key: item,
        value: item,
        text: _.get(
          _.find(this.props.userObjs, (user) => user.userId === item),
          'emailAdr',
          'Unknown Email'
        ),
      }))
    );

    const taskOptions = _.concat(
      [{key: 0, value: '', text: ''}],
      _.map(_.sortBy(_.values(this.props.taskNameList)), (item) => ({
        key: item,
        value: item,
        text: item,
      }))
    );

    const sortByOptions = [
      {key: 'DateInQueue', value: 'created', text: 'Days in queue'},
      {
        key: 'Flagged',
        value: 'followUpRequired',
        text: 'Flagged for follow-up',
      },
      {key: 'Grant ID', value: 'grantId', text: 'Grant ID'},
      {
        key: 'priority',
        value: 'priority',
        text: 'Priority',
      },
      {key: 'TaskType', value: 'name', text: 'Task'},
    ];

    const REGION_OPTIONS_MOD = _.map(REGION_OPTIONS, (r) => ({...r, value: r.text}));

    if (workloadHMAToggle)
      sortByOptions.splice(3, 0, {
        key: 'Subgrant ID',
        value: 'subGrantId',
        text: 'Subgrant ID',
      });

    return (
      <Form>
        <Header as="h3">Search</Header>
        <TextBoxField
          title="Search by grant ID"
          value={filtersAsEntered.grantId}
          name="grantId"
          label="Grant ID"
          id="searchString"
          handleChange={this.setFilter}
        />
        {workloadHMAToggle && (
          <TextBoxField
            title="Search by Sub Grant ID"
            value={filtersAsEntered.subGrantId}
            name="subGrantId"
            label="Subgrant ID"
            id="searchSubGrantString"
            handleChange={this.setFilter}
          />
        )}
        <Header as="h6" textAlign="right">
          <a href="#" className="table-link" tabindex="0" onClick={this.clearAllFilters}>
            Clear Filters
          </a>
        </Header>
        <InlineSelect
          placeholder=""
          id="assignee"
          label="Assigned To"
          search
          selection
          title="assignee"
          name="assignee"
          value={filtersAsEntered.assignee}
          handleChange={this.setSelectFilterFollow}
          options={assigneeOptions}
        />
        <TextBoxField
          title="Filter by funding opportunity"
          value={filtersAsEntered.fundingOpportunityNumber}
          name="fundingOpportunityNumber"
          label="Funding opportunity"
          id="fundingOpportunityNumber"
          handleChange={this.setFilter}
        />
        <InlineSelect
          placeholder=""
          id="name"
          label="Task"
          search
          selection
          title="Filter by task"
          name="name"
          value={filtersAsEntered.name}
          handleChange={this.setSelectFilterFollow}
          options={taskOptions}
        />
        {workloadHMAToggle && (
          <InlineSelect
            placeholder="region"
            id="region"
            label="Region"
            title="region"
            name="region"
            value={filtersAsEntered.region}
            handleChange={this.setSelectFilterFollow}
            options={REGION_OPTIONS_MOD}
          />
        )}
        <InlineSelect
          placeholder=""
          id="followUpRequired"
          label="Flagged for follow-up"
          labeled="true"
          search
          selection
          title="followUpRequired"
          name="followUpRequired"
          value={filtersAsEntered.followUpRequired}
          handleChange={this.setSelectFilterFollow}
          options={[
            {key: '', value: null, text: ''},
            {key: 'flagged', text: 'Flagged for follow-up', value: true},
          ]}
        />
        <Header as="h3">Sort</Header>
        <InlineSelect
          placeholder="Sort by"
          search
          selection
          title="Sort"
          value={filtersAsEntered.sortBy}
          name="sortBy"
          id="sortBy"
          label="Sort by"
          handleChange={this.setSelectFilter}
          options={sortByOptions}
        />
        <Form.Field>
          <RadioField
            name="sortOrder"
            handleChange={this.handleDateFilter}
            value={filtersAsEntered.sortOrder}
            options={[
              {label: 'Ascending (A-Z)', value: 'asc'},
              {label: 'Descending (Z-A)', value: 'desc'},
            ]}
          />
        </Form.Field>
      </Form>
    );
  }
}

export default WorkloadFilter;
